/* mh-card-carousel.js — site-wide product-card image carousel.
 *
 * Fully EVENT-DELEGATED: works on server-rendered cards, JS-injected cards
 * (dynamic homepage sections), and slider clones alike — no per-node init,
 * no re-init hooks needed. Previously the logic lived inside the
 * product-card-new snippet's <script>, which never executes on pages that
 * inject card HTML client-side (scripts inside innerHTML don't run), so
 * homepage cards showed dots/arrows but never cycled.
 *
 * Behaviour:
 *   hover card  → auto-advance every DELAY ms
 *   leave card  → stop + reset to first image
 *   arrows/dots → manual jump (pauses auto until re-hover)
 *   touch swipe → manual prev/next
 */
(function () {
  if (window.__mhCardCarouselDelegated) return;
  window.__mhCardCarouselDelegated = true;

  var DELAY = 1400;

  function carouselWrap(card) {
    return card.querySelector('.mh-card-image-wrap[data-carousel="true"]');
  }
  function slidesOf(wrap) {
    return wrap.querySelectorAll('.mh-carousel-slide');
  }
  function currentIdx(slides) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('active')) return i;
    }
    return 0;
  }
  function go(wrap, idx) {
    var slides = slidesOf(wrap);
    if (slides.length <= 1) return;
    var dots = wrap.querySelectorAll('.mh-dot');
    var cur = currentIdx(slides);
    if (idx >= slides.length) idx = 0;
    if (idx < 0) idx = slides.length - 1;
    // Non-first slides are loading="lazy"; force the target (and the one
    // after it) to fetch NOW so navigation never lands on a blank image.
    [idx, (idx + 1) % slides.length].forEach(function (n) {
      var s = slides[n];
      if (s && s.tagName === 'IMG' && s.loading === 'lazy') s.loading = 'eager';
    });
    slides[cur].classList.remove('active');
    if (dots[cur]) dots[cur].classList.remove('active');
    slides[idx].classList.add('active');
    if (dots[idx]) dots[idx].classList.add('active');
  }
  function startAuto(wrap) {
    stopAuto(wrap);
    wrap.__mhCarTimer = setInterval(function () {
      // Element detached (slider re-render / page swap) → self-clean.
      if (!wrap.isConnected) { stopAuto(wrap); return; }
      go(wrap, currentIdx(slidesOf(wrap)) + 1);
    }, DELAY);
  }
  function stopAuto(wrap) {
    if (wrap.__mhCarTimer) {
      clearInterval(wrap.__mhCarTimer);
      wrap.__mhCarTimer = null;
    }
  }

  // Hover enter/leave via delegated mouseover/mouseout + relatedTarget
  // containment checks (mouseenter/leave don't bubble, these do).
  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.mh-card');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return; // intra-card move
    var wrap = carouselWrap(card);
    if (wrap) startAuto(wrap);
  }, true);

  document.addEventListener('mouseout', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.mh-card');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return; // intra-card move
    var wrap = carouselWrap(card);
    if (wrap) { stopAuto(wrap); go(wrap, 0); }
  }, true);

  // Arrows + dots
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.mh-carousel-prev, .mh-carousel-next, .mh-dot');
    if (!btn) return;
    var wrap = btn.closest('.mh-card-image-wrap[data-carousel="true"]');
    if (!wrap) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('mh-carousel-prev')) {
      go(wrap, currentIdx(slidesOf(wrap)) - 1);
    } else if (btn.classList.contains('mh-carousel-next')) {
      go(wrap, currentIdx(slidesOf(wrap)) + 1);
    } else {
      go(wrap, parseInt(btn.getAttribute('data-index') || '0', 10));
    }
    stopAuto(wrap);
  }, true);

  // Touch swipe
  var swipeWrap = null;
  var swipeX = 0;
  document.addEventListener('touchstart', function (e) {
    var t = e.target;
    swipeWrap = (t && t.closest) ? t.closest('.mh-card-image-wrap[data-carousel="true"]') : null;
    if (swipeWrap) swipeX = e.changedTouches[0].screenX;
  }, { passive: true, capture: true });
  document.addEventListener('touchend', function (e) {
    if (!swipeWrap) return;
    var diff = swipeX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 40) {
      go(swipeWrap, currentIdx(slidesOf(swipeWrap)) + (diff > 0 ? 1 : -1));
    }
    swipeWrap = null;
  }, { passive: true, capture: true });
})();
